import { UrlDialog } from 'components/UrlDialog';
import { useDisclose } from 'hooks/utilHooks';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { PRIVACY_POLICY_URL, PRIVACY_TERMS_URL } from 'util/constants';

import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  Link,
  Typography,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { IPartnerPreRegistration } from 'types/Auth';

export const TermsForm: React.FC = () => {
  const privacyTerms = useDisclose();
  const privacyPolicy = useDisclose();
  const { setValue } = useFormContext<IPartnerPreRegistration>();

  return (
    <Grid item container xs={12} md={12} mb={2}>
      <Grid item xs={12} md={12}>
        <Controller
          name="acceptTerms.isAccepted"
          render={({ field: { value, onBlur }, fieldState }) => {
            const hasError = Boolean(fieldState.error?.message);

            const handleChange = () => {
              setValue('acceptTerms.isAccepted', !value, {
                shouldValidate: true,
              });
            };

            return (
              <FormControl
                component="fieldset"
                required={true}
                error={hasError}
              >
                <FormControlLabel
                  name="acceptTerms"
                  label={
                    <Typography
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      variant="body2"
                    >
                      <Typography
                        component="span"
                        onClick={handleChange}
                        variant="body2"
                      >
                        {'Eu aceito e concordo com a '}
                      </Typography>

                      <Link onClick={privacyPolicy.onOpen} underline="hover">
                        Política de privacidade
                      </Link>

                      {' e '}

                      <Link onClick={privacyTerms.onOpen} underline="hover">
                        Termos de uso
                      </Link>
                    </Typography>
                  }
                  labelPlacement="end"
                  checked={value}
                  value={value}
                  onBlur={onBlur}
                  onClick={(e) => {
                    e.preventDefault();

                    handleChange();
                  }}
                  control={<MuiCheckbox />}
                />

                <FormHelperText>{fieldState.error?.message}</FormHelperText>
              </FormControl>
            );
          }}
        />
      </Grid>

      <UrlDialog
        open={privacyPolicy.isOpen}
        onClose={privacyPolicy.onClose}
        url={PRIVACY_POLICY_URL}
        title="Política de privacidade"
      />

      <UrlDialog
        open={privacyTerms.isOpen}
        onClose={privacyTerms.onClose}
        url={PRIVACY_TERMS_URL}
        title="Termos de uso"
      />
    </Grid>
  );
};
